import baseTimes from './_baseTimes';
import isArguments from './isArguments';
import isArray from './isArray';
import isLength from './isLength';
import isString from './isString';

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

export default indexKeys;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_indexKeys.js
// module id = null
// module chunks = 